import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const infoCardThemeNeutral = createTheme(
  `InfoCardNeutral`,
  defaultTheme.api,
  {
    colors: {
      backgroundPrimary: `goldDark`,
      backgroundPrimaryStart: `goldDark`,
      backgroundPrimaryEnd: `goldDark`,
      title: `white`,
      bodyBackground: `goldPale`,
      highlight: `goldDark`,
    },
  },
  defaultTheme
)

export default infoCardThemeNeutral
